import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageSquare, Star, ChevronDown, ChevronLeft, ChevronRight, ThumbsUp, ThumbsDown, Minus, Store, Search, Sparkles, X, Copy, Check, Tag } from 'lucide-react';
import { KPICard } from '../components/ui/KPICard';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { markets } from './MarktStimmungPage';
const topicConfig: Record<string, {
  label: string;
  color: string;
}> = {
  wartezeit: {
    label: 'Wartezeit',
    color: 'bg-orange-100 text-orange-700'
  },
  personal: {
    label: 'Personal',
    color: 'bg-purple-100 text-purple-700'
  },
  frische: {
    label: 'Frische',
    color: 'bg-green-100 text-green-700'
  },
  preise: {
    label: 'Preise',
    color: 'bg-blue-100 text-blue-700'
  },
  sortiment: {
    label: 'Sortiment',
    color: 'bg-indigo-100 text-indigo-700'
  },
  sauberkeit: {
    label: 'Sauberkeit',
    color: 'bg-cyan-100 text-cyan-700'
  },
  service: {
    label: 'Service',
    color: 'bg-pink-100 text-pink-700'
  },
  qualitaet: {
    label: 'Qualität',
    color: 'bg-emerald-100 text-emerald-700'
  },
  parkplatz: {
    label: 'Parkplatz',
    color: 'bg-amber-100 text-amber-700'
  },
  atmosphaere: {
    label: 'Atmosphäre',
    color: 'bg-violet-100 text-violet-700'
  }
};
const allReviews = [{
  id: 1,
  marketId: 'hamburg-hafencity',
  store: 'ALDI Nord Hamburg-Hafencity',
  author: 'Thomas M.',
  date: '2024-01-28',
  stars: 1,
  text: 'Sehr lange Wartezeit an der Kasse, obwohl nur 3 Kunden vor mir waren. Personal wirkte unmotiviert und unfreundlich.',
  sentiment: 'negative' as const,
  source: 'google' as const,
  responded: false,
  topic: 'wartezeit'
}, {
  id: 2,
  marketId: 'berlin-kreuzberg',
  store: 'ALDI Nord Berlin-Kreuzberg',
  author: 'Sandra K.',
  date: '2024-01-28',
  stars: 2,
  text: 'Gemüseabteilung hatte viele welke Produkte. Preise sind auch deutlich höher als bei der Konkurrenz.',
  sentiment: 'negative' as const,
  source: 'trustpilot' as const,
  responded: false,
  topic: 'frische'
}, {
  id: 3,
  marketId: 'hannover-mitte',
  store: 'ALDI Nord Hannover-Mitte',
  author: 'Michael B.',
  date: '2024-01-27',
  stars: 4,
  text: 'Gute Auswahl und freundliches Personal. Nur die Parkplatzsituation ist manchmal schwierig.',
  sentiment: 'positive' as const,
  source: 'aldi-stimme' as const,
  responded: true,
  topic: 'parkplatz'
}, {
  id: 4,
  marketId: 'koeln-ehrenfeld',
  store: 'ALDI Nord Köln-Ehrenfeld',
  author: 'Lisa W.',
  date: '2024-01-27',
  stars: 1,
  text: 'Absolut inakzeptabel! Abgelaufene Produkte im Regal gefunden.',
  sentiment: 'negative' as const,
  source: 'google' as const,
  responded: false,
  topic: 'frische'
}, {
  id: 5,
  marketId: 'frankfurt-sachsenhausen',
  store: 'ALDI Nord Frankfurt-Sachsenhausen',
  author: 'Peter H.',
  date: '2024-01-26',
  stars: 5,
  text: 'Bester ALDI in der Gegend! Tolle Weinauswahl und das Personal kennt sich aus.',
  sentiment: 'positive' as const,
  source: 'trustpilot' as const,
  responded: true,
  topic: 'sortiment'
}, {
  id: 6,
  marketId: 'dortmund-innenstadt',
  store: 'ALDI Nord Dortmund-Innenstadt',
  author: 'Anna S.',
  date: '2024-01-26',
  stars: 3,
  text: 'Durchschnittlicher Supermarkt. Nichts Besonderes, aber auch nichts Schlechtes.',
  sentiment: 'neutral' as const,
  source: 'aldi-stimme' as const,
  responded: false,
  topic: 'preise'
}, {
  id: 7,
  marketId: 'hamburg-hafencity',
  store: 'ALDI Nord Hamburg-Hafencity',
  author: 'Klaus R.',
  date: '2024-01-25',
  stars: 2,
  text: 'Der Laden ist oft unordentlich und die Regale nicht aufgefüllt.',
  sentiment: 'negative' as const,
  source: 'google' as const,
  responded: false,
  topic: 'sauberkeit'
}, {
  id: 8,
  marketId: 'leipzig-sued',
  store: 'ALDI Nord Leipzig-Süd',
  author: 'Maria G.',
  date: '2024-01-25',
  stars: 5,
  text: 'Hervorragend! Die neue Backstation ist fantastisch. Personal ist immer hilfsbereit.',
  sentiment: 'positive' as const,
  source: 'trustpilot' as const,
  responded: true,
  topic: 'sortiment'
}, {
  id: 9,
  marketId: 'muenster-zentrum',
  store: 'ALDI Nord Münster-Zentrum',
  author: 'Frank M.',
  date: '2024-01-24',
  stars: 4,
  text: 'Sehr gute Qualität bei Obst und Gemüse. Die Mitarbeiter sind freundlich.',
  sentiment: 'positive' as const,
  source: 'aldi-stimme' as const,
  responded: false,
  topic: 'qualitaet'
}, {
  id: 10,
  marketId: 'osnabrueck-zentrum',
  store: 'ALDI Nord Osnabrück-Zentrum',
  author: 'Sabine L.',
  date: '2024-01-24',
  stars: 3,
  text: 'Ganz okay, aber die Preise könnten etwas niedriger sein.',
  sentiment: 'neutral' as const,
  source: 'google' as const,
  responded: true,
  topic: 'preise'
}, {
  id: 11,
  marketId: 'hamburg-hafencity',
  store: 'ALDI Nord Hamburg-Hafencity',
  author: 'Petra W.',
  date: '2024-01-23',
  stars: 5,
  text: 'Toller Service! Die Mitarbeiter haben mir geholfen, ein spezielles Produkt zu finden.',
  sentiment: 'positive' as const,
  source: 'trustpilot' as const,
  responded: true,
  topic: 'service'
}, {
  id: 12,
  marketId: 'hannover-mitte',
  store: 'ALDI Nord Hannover-Mitte',
  author: 'Hans M.',
  date: '2024-01-22',
  stars: 5,
  text: 'Beste Fleischqualität! Die Beratung ist erstklassig.',
  sentiment: 'positive' as const,
  source: 'aldi-stimme' as const,
  responded: false,
  topic: 'qualitaet'
}];
const aiResponses: Record<string, string> = {
  negative: `Sehr geehrte/r Kunde/in,

vielen Dank für Ihr ehrliches Feedback. Es tut uns aufrichtig leid, dass Ihr Einkaufserlebnis nicht unseren hohen Standards entsprochen hat.

Wir nehmen Ihre Kritik sehr ernst und haben Ihre Anmerkungen bereits an die Filialleitung weitergeleitet. Unser Team wird die angesprochenen Punkte umgehend prüfen und Verbesserungsmaßnahmen einleiten.

Bitte kontaktieren Sie uns unter kundenservice@aldi-nord.de, damit wir den Vorfall genauer besprechen können.

Wir würden uns freuen, Sie bald wieder bei uns begrüßen zu dürfen.

Mit freundlichen Grüßen,
Ihr ALDI Nord-Team`,
  neutral: `Sehr geehrte/r Kunde/in,

vielen Dank, dass Sie sich die Zeit genommen haben, uns zu bewerten.

Wir freuen uns, dass Sie grundsätzlich zufrieden waren, und arbeiten kontinuierlich daran, unser Angebot und unseren Service zu verbessern.

Haben Sie konkrete Vorschläge, wie wir Ihr Einkaufserlebnis noch besser gestalten können? Wir freuen uns über Ihr Feedback!

Mit freundlichen Grüßen,
Ihr ALDI Nord-Team`,
  positive: `Sehr geehrte/r Kunde/in,

herzlichen Dank für Ihre tolle Bewertung! Es freut uns sehr zu hören, dass Sie mit Ihrem Einkauf zufrieden waren.

Ihr Lob werden wir gerne an unser Team weitergeben – solches Feedback motiviert uns jeden Tag aufs Neue!

Wir freuen uns auf Ihren nächsten Besuch.

Mit freundlichen Grüßen,
Ihr ALDI Nord-Team`
};
const GoogleIcon = () => <svg viewBox="0 0 24 24" className="w-4 h-4" data-id="element-243">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-244" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-245" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-246" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-247" />
  </svg>;
const TrustpilotIcon = () => <svg viewBox="0 0 24 24" className="w-4 h-4" data-id="element-248">
    <path fill="#00B67A" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-249" />
  </svg>;
const AldiStimmeIcon = () => <div className="w-4 h-4 rounded-full bg-aldi-blue flex items-center justify-center" data-id="element-250">
    <span className="text-[8px] font-bold text-white" data-id="element-251">A</span>
  </div>;
const ITEMS_PER_PAGE = 10;
interface ActionHubPageProps {
  selectedMarket: string | null;
  onMarketChange: (marketId: string | null) => void;
}
export function ActionHubPage({
  selectedMarket,
  onMarketChange
}: ActionHubPageProps) {
  const [sentimentFilter, setSentimentFilter] = useState<'all' | 'positive' | 'neutral' | 'negative'>('all');
  const [sourceFilter, setSourceFilter] = useState<'all' | 'google' | 'trustpilot' | 'aldi-stimme'>('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState<(typeof allReviews)[0] | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const filteredMarkets = markets.filter(m => m.name.toLowerCase().includes(searchQuery.toLowerCase()) || m.region.toLowerCase().includes(searchQuery.toLowerCase()));
  const selectedMarketInfo = markets.find(m => m.id === selectedMarket);
  const marketReviews = selectedMarket ? allReviews.filter(r => r.marketId === selectedMarket) : [];
  const filteredReviews = marketReviews.filter(review => sentimentFilter === 'all' || review.sentiment === sentimentFilter).filter(review => sourceFilter === 'all' || review.source === sourceFilter).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const totalPages = Math.ceil(filteredReviews.length / ITEMS_PER_PAGE);
  const paginatedReviews = filteredReviews.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  const handleFilterChange = (filterFn: () => void) => {
    filterFn();
    setCurrentPage(1);
  };
  const stats = {
    total: marketReviews.length,
    positive: marketReviews.filter(r => r.sentiment === 'positive').length,
    neutral: marketReviews.filter(r => r.sentiment === 'neutral').length,
    negative: marketReviews.filter(r => r.sentiment === 'negative').length,
    avgRating: marketReviews.reduce((acc, r) => acc + r.stars, 0) / marketReviews.length || 0
  };
  const getStarColor = (stars: number) => {
    if (stars <= 2) return 'text-[#E03C32]';
    if (stars <= 3) return 'text-[#FFD301]';
    return 'text-[#639754]';
  };
  const getSourceIcon = (source: string) => {
    switch (source) {
      case 'google':
        return <GoogleIcon data-id="element-252" />;
      case 'trustpilot':
        return <TrustpilotIcon data-id="element-253" />;
      case 'aldi-stimme':
        return <AldiStimmeIcon data-id="element-254" />;
      default:
        return null;
    }
  };
  const getSourceLabel = (source: string) => {
    switch (source) {
      case 'google':
        return 'Google';
      case 'trustpilot':
        return 'Trustpilot';
      case 'aldi-stimme':
        return 'ALDI Kundenstimme';
      default:
        return source;
    }
  };
  const getSourceStyle = (source: string) => {
    switch (source) {
      case 'google':
        return 'bg-blue-50 text-blue-700';
      case 'trustpilot':
        return 'bg-green-50 text-green-700';
      case 'aldi-stimme':
        return 'bg-aldi-blue/10 text-aldi-blue';
      default:
        return 'bg-gray-50 text-gray-700';
    }
  };
  const openReplyModal = (review: (typeof allReviews)[0]) => {
    setSelectedReview(review);
    setIsModalOpen(true);
    setCopied(false);
  };
  const handleCopyText = () => {
    if (selectedReview) {
      const text = aiResponses[selectedReview.sentiment];
      navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };
  if (!selectedMarket) {
    return <div className="p-6 space-y-6 overflow-y-auto h-screen" data-id="element-255">
        <Card className="!p-6" data-id="element-256">
          <div className="text-center mb-6" data-id="element-257">
            <div className="w-16 h-16 rounded-2xl bg-aldi-blue/10 flex items-center justify-center mx-auto mb-4" data-id="element-258">
              <Store size={32} className="text-aldi-blue" data-id="element-259" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-260">
              Markt auswählen
            </h2>
            <p className="text-gray-500 text-sm" data-id="element-261">
              Wählen Sie einen Markt aus, um die Bewertungen anzuzeigen
            </p>
          </div>
          <div className="relative mb-4" data-id="element-262">
            <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-263" />
            <input type="text" placeholder="Markt suchen..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-aldi-blue/20 focus:border-aldi-blue" data-id="element-264" />
          </div>
          <div className="space-y-2 max-h-96 overflow-y-auto" data-id="element-265">
            {filteredMarkets.map(market => <button key={market.id} onClick={() => {
            onMarketChange(market.id);
            setCurrentPage(1);
          }} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-aldi-blue hover:bg-aldi-blue/5 transition-all text-left" data-id="element-266">
                <div className="flex items-center gap-3" data-id="element-267">
                  <div className="w-10 h-10 rounded-full bg-aldi-blue/10 flex items-center justify-center" data-id="element-268">
                    <Store size={18} className="text-aldi-blue" data-id="element-269" />
                  </div>
                  <div data-id="element-270">
                    <div className="font-medium text-gray-900" data-id="element-271">
                      {market.name}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-272">{market.region}</div>
                  </div>
                </div>
                <div className="text-right" data-id="element-273">
                  <div className="flex items-center gap-1" data-id="element-274">
                    {[...Array(5)].map((_, i) => <span key={i} className={`text-sm ${i < Math.floor(market.rating) ? 'text-yellow-400' : 'text-gray-200'}`} data-id="element-275">
                        ★
                      </span>)}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-276">
                    {market.rating.toFixed(1)} Sterne
                  </div>
                </div>
              </button>)}
          </div>
        </Card>
      </div>;
  }
  return <div className="p-6 space-y-6 overflow-y-auto h-screen" data-id="element-277">
      <Card className="!p-4" data-id="element-278">
        <div className="flex items-center gap-4 flex-wrap" data-id="element-279">
          <div className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-280">
            <Store size={16} data-id="element-281" />
            <span data-id="element-282">Markt:</span>
          </div>
          <div className="relative flex-1 max-w-md" data-id="element-283">
            <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="w-full flex items-center justify-between px-4 py-2.5 bg-aldi-blue text-white rounded-lg shadow-md" data-id="element-284">
              <div className="flex items-center gap-2" data-id="element-285">
                <Store size={16} data-id="element-286" />
                <span className="font-medium" data-id="element-287">{selectedMarketInfo?.name}</span>
              </div>
              <ChevronDown size={16} className={`transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} data-id="element-288" />
            </button>
            {isDropdownOpen && <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-lg shadow-xl border border-gray-200 z-50 max-h-64 overflow-y-auto" data-id="element-289">
                <div className="p-2" data-id="element-290">
                  <input type="text" placeholder="Suchen..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-aldi-blue/20" data-id="element-291" />
                </div>
                {filteredMarkets.map(market => <button key={market.id} onClick={() => {
              onMarketChange(market.id);
              setIsDropdownOpen(false);
              setSearchQuery('');
              setCurrentPage(1);
            }} className={`w-full flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 text-left ${market.id === selectedMarket ? 'bg-aldi-blue/5' : ''}`} data-id="element-292">
                    <Store size={14} className="text-gray-400" data-id="element-293" />
                    <div className="flex-1" data-id="element-294">
                      <div className="text-sm font-medium text-gray-900" data-id="element-295">
                        {market.name}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-296">
                        {market.region}
                      </div>
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-297">
                      {market.rating.toFixed(1)} ★
                    </div>
                  </button>)}
              </div>}
          </div>
          <button onClick={() => onMarketChange(null)} className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-298">
            Markt wechseln
          </button>
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-299">
        <KPICard title="Bewertungen" value={stats.total.toString()} icon={<MessageSquare size={18} data-id="element-301" />} data-id="element-300" />
        <KPICard title="Ø Bewertung" value={stats.avgRating.toFixed(1)} icon={<Star size={18} data-id="element-303" />} data-id="element-302" />
        <KPICard title="Positiv" value={stats.positive.toString()} icon={<ThumbsUp size={18} data-id="element-305" />} variant="positive" data-id="element-304" />
        <KPICard title="Neutral" value={stats.neutral.toString()} icon={<Minus size={18} data-id="element-307" />} variant="neutral" data-id="element-306" />
        <KPICard title="Negativ" value={stats.negative.toString()} icon={<ThumbsDown size={18} data-id="element-309" />} variant="negative" data-id="element-308" />
      </div>

      <Card className="!p-4" data-id="element-310">
        <div className="flex items-center justify-between flex-wrap gap-4" data-id="element-311">
          <div className="flex items-center gap-3" data-id="element-312">
            <span className="text-sm font-medium text-gray-700" data-id="element-313">
              Sentiment:
            </span>
            <div className="flex gap-2" data-id="element-314">
              <button onClick={() => handleFilterChange(() => setSentimentFilter('all'))} className={`px-3 py-1.5 text-sm rounded-md transition-colors ${sentimentFilter === 'all' ? 'bg-aldi-blue text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-315">
                Alle ({marketReviews.length})
              </button>
              <button onClick={() => handleFilterChange(() => setSentimentFilter('positive'))} className={`px-3 py-1.5 text-sm rounded-md transition-colors flex items-center gap-1.5 ${sentimentFilter === 'positive' ? 'text-white' : 'text-[#639754] hover:opacity-80'}`} style={{
              backgroundColor: sentimentFilter === 'positive' ? '#639754' : '#e8f0e5'
            }} data-id="element-316">
                <ThumbsUp size={14} data-id="element-317" /> Positiv ({stats.positive})
              </button>
              <button onClick={() => handleFilterChange(() => setSentimentFilter('neutral'))} className={`px-3 py-1.5 text-sm rounded-md transition-colors flex items-center gap-1.5 ${sentimentFilter === 'neutral' ? 'text-gray-800' : 'text-[#b39500] hover:opacity-80'}`} style={{
              backgroundColor: sentimentFilter === 'neutral' ? '#FFD301' : '#fff9db'
            }} data-id="element-318">
                <Minus size={14} data-id="element-319" /> Neutral ({stats.neutral})
              </button>
              <button onClick={() => handleFilterChange(() => setSentimentFilter('negative'))} className={`px-3 py-1.5 text-sm rounded-md transition-colors flex items-center gap-1.5 ${sentimentFilter === 'negative' ? 'text-white' : 'text-[#E03C32] hover:opacity-80'}`} style={{
              backgroundColor: sentimentFilter === 'negative' ? '#E03C32' : '#fce8e7'
            }} data-id="element-320">
                <ThumbsDown size={14} data-id="element-321" /> Negativ ({stats.negative})
              </button>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-322">
            <span className="text-sm font-medium text-gray-700" data-id="element-323">Quelle:</span>
            <div className="flex gap-2" data-id="element-324">
              <button onClick={() => handleFilterChange(() => setSourceFilter('all'))} className={`px-3 py-1.5 text-sm rounded-md transition-colors ${sourceFilter === 'all' ? 'bg-aldi-blue text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-325">
                Alle
              </button>
              <button onClick={() => handleFilterChange(() => setSourceFilter('google'))} className={`px-3 py-1.5 text-sm rounded-md transition-colors flex items-center gap-1.5 ${sourceFilter === 'google' ? 'bg-blue-600 text-white' : 'bg-blue-50 text-blue-700 hover:bg-blue-100'}`} data-id="element-326">
                <GoogleIcon data-id="element-327" /> Google
              </button>
              <button onClick={() => handleFilterChange(() => setSourceFilter('trustpilot'))} className={`px-3 py-1.5 text-sm rounded-md transition-colors flex items-center gap-1.5 ${sourceFilter === 'trustpilot' ? 'bg-green-600 text-white' : 'bg-green-50 text-green-700 hover:bg-green-100'}`} data-id="element-328">
                <TrustpilotIcon data-id="element-329" /> Trustpilot
              </button>
              <button onClick={() => handleFilterChange(() => setSourceFilter('aldi-stimme'))} className={`px-3 py-1.5 text-sm rounded-md transition-colors flex items-center gap-1.5 ${sourceFilter === 'aldi-stimme' ? 'bg-aldi-blue text-white' : 'bg-aldi-blue/10 text-aldi-blue hover:bg-aldi-blue/20'}`} data-id="element-330">
                <AldiStimmeIcon data-id="element-331" /> Kundenstimme
              </button>
            </div>
          </div>
        </div>
      </Card>

      <div className="flex items-center justify-between" data-id="element-332">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-333">
          Alle Bewertungen für{' '}
          <span className="text-aldi-blue" data-id="element-334">{selectedMarketInfo?.name}</span>
        </h2>
        <span className="text-sm text-gray-500" data-id="element-335">
          {filteredReviews.length} Bewertungen gefunden
        </span>
      </div>

      <div className="space-y-3" data-id="element-336">
        {paginatedReviews.length === 0 ? <Card className="!p-8 text-center" data-id="element-337">
            <p className="text-gray-500" data-id="element-338">
              Keine Bewertungen für diese Filter gefunden.
            </p>
          </Card> : paginatedReviews.map((review, index) => <motion.div key={review.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.03
      }} data-id="element-339">
              <Card className="!p-0 overflow-hidden" data-id="element-340">
                <div className="flex" data-id="element-341">
                  <div className="w-1.5" style={{
              backgroundColor: review.sentiment === 'positive' ? '#639754' : review.sentiment === 'neutral' ? '#FFD301' : '#E03C32'
            }} data-id="element-342" />
                  <div className="flex-1 p-4" data-id="element-343">
                    <div className="flex items-start justify-between gap-4" data-id="element-344">
                      <div className="flex-1 min-w-0" data-id="element-345">
                        <div className="flex items-center gap-3 mb-2 flex-wrap" data-id="element-346">
                          <div className="flex items-center gap-1" data-id="element-347">
                            {[...Array(5)].map((_, i) => <Star key={i} size={14} className={i < review.stars ? getStarColor(review.stars) : 'text-gray-200'} fill={i < review.stars ? 'currentColor' : 'none'} data-id="element-348" />)}
                          </div>
                          <div className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${topicConfig[review.topic]?.color || 'bg-gray-100 text-gray-600'}`} data-id="element-349">
                            <Tag size={10} data-id="element-350" />{' '}
                            {topicConfig[review.topic]?.label || review.topic}
                          </div>
                          <div className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${getSourceStyle(review.source)}`} data-id="element-351">
                            {getSourceIcon(review.source)}{' '}
                            {getSourceLabel(review.source)}
                          </div>
                          <span className="text-sm text-gray-500" data-id="element-352">
                            {review.author}
                          </span>
                          <span className="text-sm text-gray-400" data-id="element-353">•</span>
                          <span className="text-sm text-gray-500" data-id="element-354">
                            {new Date(review.date).toLocaleDateString('de-DE')}
                          </span>
                          {review.responded && <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-700 font-medium" data-id="element-355">
                              Beantwortet
                            </span>}
                        </div>
                        <p className="text-sm text-gray-700" data-id="element-356">{review.text}</p>
                      </div>
                      <div className="shrink-0" data-id="element-357">
                        <Button variant={review.responded ? 'outline' : 'primary'} size="sm" onClick={() => openReplyModal(review)} className="gap-2" data-id="element-358">
                          <Sparkles size={14} data-id="element-359" />
                          {review.responded ? 'Antwort bearbeiten' : 'Mit KI antworten'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </motion.div>)}
      </div>

      {totalPages > 1 && <div className="flex items-center justify-center gap-2 pt-4" data-id="element-360">
          <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} className="p-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-361">
            <ChevronLeft size={18} data-id="element-362" />
          </button>
          <div className="flex items-center gap-1" data-id="element-363">
            {Array.from({
          length: totalPages
        }, (_, i) => i + 1).map(page => <button key={page} onClick={() => setCurrentPage(page)} className={`w-9 h-9 rounded-lg text-sm font-medium transition-colors ${currentPage === page ? 'bg-aldi-blue text-white' : 'hover:bg-gray-100 text-gray-600'}`} data-id="element-364">
                {page}
              </button>)}
          </div>
          <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="p-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-365">
            <ChevronRight size={18} data-id="element-366" />
          </button>
        </div>}

      <AnimatePresence data-id="element-367">
        {isModalOpen && selectedReview && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/50 flex items-center justify-center z-[600] p-4" onClick={() => setIsModalOpen(false)} data-id="element-368">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-369">
              <div className="p-6 border-b border-gray-200 bg-gray-50" data-id="element-370">
                <div className="flex items-center justify-between" data-id="element-371">
                  <div data-id="element-372">
                    <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2" data-id="element-373">
                      <Sparkles className="text-aldi-accent" size={20} data-id="element-374" />{' '}
                      KI-Antwortvorschlag
                    </h3>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-375">
                      Basierend auf der Rezension von {selectedReview.author}
                    </p>
                  </div>
                  <button onClick={() => setIsModalOpen(false)} className="p-2 hover:bg-gray-200 rounded-full transition-colors" data-id="element-376">
                    <X size={20} data-id="element-377" />
                  </button>
                </div>
              </div>
              <div className="p-6 border-b border-gray-100 bg-gray-50/50" data-id="element-378">
                <div className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2" data-id="element-379">
                  Original-Rezension
                </div>
                <div className="flex items-center gap-2 mb-2 flex-wrap" data-id="element-380">
                  {[...Array(5)].map((_, i) => <Star key={i} size={14} className={i < selectedReview.stars ? getStarColor(selectedReview.stars) : 'text-gray-200'} fill={i < selectedReview.stars ? 'currentColor' : 'none'} data-id="element-381" />)}
                  <div className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${topicConfig[selectedReview.topic]?.color || 'bg-gray-100 text-gray-600'}`} data-id="element-382">
                    <Tag size={10} data-id="element-383" />{' '}
                    {topicConfig[selectedReview.topic]?.label || selectedReview.topic}
                  </div>
                  <div className={`flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${getSourceStyle(selectedReview.source)}`} data-id="element-384">
                    {getSourceIcon(selectedReview.source)}{' '}
                    {getSourceLabel(selectedReview.source)}
                  </div>
                  <span className="text-sm text-gray-500" data-id="element-385">
                    {selectedReview.store}
                  </span>
                </div>
                <p className="text-sm text-gray-700 italic" data-id="element-386">
                  "{selectedReview.text}"
                </p>
              </div>
              <div className="p-6 overflow-y-auto max-h-[40vh]" data-id="element-387">
                <div className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-3" data-id="element-388">
                  Vorgeschlagene Antwort
                </div>
                <textarea className="w-full h-64 p-4 border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-aldi-blue/20 focus:border-aldi-blue resize-none" defaultValue={aiResponses[selectedReview.sentiment]} data-id="element-389" />
              </div>
              <div className="p-6 border-t border-gray-200 bg-gray-50 flex items-center justify-between" data-id="element-390">
                <Button variant="ghost" onClick={() => setIsModalOpen(false)} data-id="element-391">
                  Abbrechen
                </Button>
                <div className="flex gap-3" data-id="element-392">
                  <Button variant="outline" className="gap-2" data-id="element-393">
                    <Sparkles size={14} data-id="element-394" /> Neu generieren
                  </Button>
                  <Button variant="primary" className="gap-2" onClick={handleCopyText} data-id="element-395">
                    {copied ? <>
                        <Check size={14} data-id="element-396" /> Kopiert!
                      </> : <>
                        <Copy size={14} data-id="element-397" /> Text kopieren
                      </>}
                  </Button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}